import { useEffect, useMemo, useState } from 'react';

// A unit becomes stale three minutes after its last check-in (server constant).
export const STALE_AFTER_MS = 180 * 1000;
export const HIDE_STALE_AFTER_MS = 24 * 60 * 60 * 1000;

export function visibleUnits(units, hideAfter24Hours = false, now = Date.now()) {
  if (hideAfter24Hours !== true) return units;
  return units.filter(unit => {
    const lastSeen = unit.lastSeenUtc ? Date.parse(unit.lastSeenUtc) : NaN;
    // Missing timestamps must not silently hide a unit.
    return !Number.isFinite(lastSeen) || now - lastSeen < STALE_AFTER_MS + HIDE_STALE_AFTER_MS;
  });
}

export function useVisibleUnits(units, hideAfter24Hours) {
  const [now, setNow] = useState(Date.now);
  useEffect(() => {
    if (hideAfter24Hours !== true) return undefined;
    const tick = () => setNow(Date.now());
    tick();
    const timer = setInterval(tick, 30000);
    window.addEventListener('focus', tick);
    document.addEventListener('visibilitychange', tick);
    return () => {
      clearInterval(timer);
      window.removeEventListener('focus', tick);
      document.removeEventListener('visibilitychange', tick);
    };
  }, [hideAfter24Hours]);
  return useMemo(() => visibleUnits(units, hideAfter24Hours, now), [units, hideAfter24Hours, now]);
}
